import { render, staticRenderFns } from "./briefings.vue?vue&type=template&id=f7df5060"
import script from "./briefings.vue?vue&type=script&lang=js"
export * from "./briefings.vue?vue&type=script&lang=js"
import style0 from "./briefings.vue?vue&type=style&index=0&id=f7df5060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports